/**
 * Theme choice (FE-02 FR-FE02-02/03): System / Light / Dark stored in `sos.theme`, applied as
 * `data-theme` on <html> (the tokens key off it). index.html applies it before first paint.
 */
export const THEMES = ["system", "light", "dark"] as const;
export type Theme = (typeof THEMES)[number];

const KEY = "sos.theme";
const THEME_COLOR = { light: "#d93a15", dark: "#111318" } as const;

export function getTheme(): Theme {
  try {
    const v = window.localStorage.getItem(KEY);
    return (THEMES as readonly string[]).includes(v ?? "") ? (v as Theme) : "system";
  } catch {
    return "system";
  }
}

function prefersDark(): boolean {
  return typeof window.matchMedia === "function"
    ? window.matchMedia("(prefers-color-scheme: dark)").matches
    : false;
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
  const dark = theme === "dark" || (theme === "system" && prefersDark());
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", dark ? THEME_COLOR.dark : THEME_COLOR.light);
}

export function setTheme(theme: Theme): void {
  try {
    if (theme === "system") window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, theme);
  } catch {
    // Private mode: applies to this page only.
  }
  applyTheme(theme);
}
